import { createTheme } from '@material-ui/core/styles';

const themeObj = {
  palette: {
    primary: {
      main: '#ffffff'
    },
    secondary: {
      main: '#214a92'
    },
    error: {
      main: '#ad0000'
    }
  },
  typography: {
    fontFamily: 'Averta Regular'
  },
  overrides: {
    MuiButton: {
      root: {
        height: '41px',
        borderRadius: '10px',
        fontSize: '16px',
        borderWidth: '10px',
        fontFamily: 'Averta Semibold'
      },
      outlined: {
        padding: '0px 25px'
      },
      contained: {
        padding: '0px 25px'
      },
      label: {
        whiteSpace: 'nowrap'
      },
      sizeSmall: {
        padding: '5px 10px',
        height: '30px'
      },
      containedPrimary: {
        color: '#2a4b8d'
      },
      containedSecondary: {
        color: '#ffffff'
      },
      outlinedPrimary: {
        border: '2px solid #ffffff',
        transition: 'all 200ms ease-in-out',
        '&:hover': {
          border: '2px solid #ffffff',
          backgroundColor: '#ffffff',
          color: '#2a4b8d'
        }
      },
      outlinedSecondary: {
        border: '2px solid #f4c01b',
        transition: 'all 200ms ease-in-out',
        '&:hover': {
          backgroundColor: '#f4c01b',
          color: '#2a4b8d'
        }
      }
    },
    MuiSvgIcon: {
      fontSizeLarge: {
        fontSize: '50px'
      }
    },
    MuiIconButton: {
      root: {
        padding: '0px'
      }
    },
    MuiMenu: {
      list: {
        backgroundColor: '#ffffff',
        padding: '15px'
      }
    },
    MuiMenuItem: {
      root: {
        fontFamily: 'Averta Regular'
      }
    },
    MuiListItem: {
      button: {
        color: '#214a92'
      }
    },
    MuiFormLabel: {
      root: {
        '&$focused': {
          color: '#214a92'
        },
        color: '#214a92',
        marginBottom: '10px'
      }
    },
    MuiFormControl: {
      root: {
        marginBottom: '.8rem'
      }
    },
    MuiOutlinedInput: {
      root: {
        '&$focused $notchedOutline': {
          borderColor: '#214a92',
          borderWidth: '2px'
        },
        '&:hover $notchedOutline': {
          borderColor: '#214a92',
          borderWidth: '2px'
        },
        borderRadius: '10px'
      },
      notchedOutline: {
        borderColor: '#214a92',
        borderWidth: '2px'
      }
    }
  }
};

const theme = createTheme(themeObj);
export { theme, themeObj };
